require("../../libs/backbone/backbone.ajaxq.adapter.ts");
var GenericView = require('views/generic.view.ts');
var Handlebars = require('handlebars');
var Template = require('text-loader!../templates/counter_monitor.template.htm');
require('dhtmlxMessage');
var QueueStatisticsCollection = require('../models/queues_statistics.paginated.collection.ts');
var SockJS = require('sockjs-client');
var Stomp = require('stompjs');
var i18n = require("l10n");
require("../../libs/jquery-countdown/js/jquery.countdown.min.js");
require('../../libs/jquery-dynamicFontSize/jquery-dynamicFontSize.js');
var popup = require('popupNew');

var PreparationPopupTemplate = require('text-loader!../templates/counter/preparationPopup.template.html');
var PreparationsTemplate = require('text-loader!../templates/counter/preparations.template.html');
var TicketsTemplate = require('text-loader!../templates/counter/tickets.template.html');
var AddTicketTemplate = require('text-loader!../templates/counter/add-ticket.template.html');


var TheView = GenericView.extend({
    el: "#container",
    tagName: 'div',
	template: Handlebars.compile(Template),
	preparationPopupTemplate: Handlebars.compile(PreparationPopupTemplate),
	preparationsTemplate: Handlebars.compile(PreparationsTemplate),
	ticketsTemplate: Handlebars.compile(TicketsTemplate),
	addTicketTemplate: Handlebars.compile(AddTicketTemplate),
	userData: null,
	queueData: null,
	counterData: null,
	currentTicket: null,
	nextCustomerTicket: null,
	nextCustomerData: null,
    nextCustomerNumberOfPeople: null,
	queueStatistic: null,
	isFirstDisplay: true,
	interval: null,
    hasCountdownStarted: false,
	queueFifo: [],
	counterStompSubscription: [],
	isTicketsContainerShown: true,
	currentCustomerInfo: {firstName: null, lastName: null},
	initialize: function (options) {
		self = this;
		this.userData = options.data;

        if(this.userData.privilegeLevel = "VenueAgent")
            this.venueAgentActions();

        this.amIAssigned();
        this.nextButtonClicked = false;

        /**
         * popstate is fired on:
         *  - url change
         *  - BACK button pressed
         *  - FORWARD button pressed
        */
        $(window).off("popstate").on("popstate", function() {
            if(self.interval)
                clearInterval(self.interval);
        });

        $(window).off("unload").on("unload", function(e) {
            e.preventDefault(); //do not show Confirm popup

            self.clearListener("beforeunload");

            if(self.interval)
                clearInterval(self.interval);

            return false;
        });

        //todo: why is this here?
        //setTimeout(function() { self.clearListener("timeout"); }, 8 * 1000);

        this.queueStatisticsCollection = new QueueStatisticsCollection();
        this.queueStatisticsCollection.off('sync').on('sync', this.successQueueStatistics, this);
	},
	venueAgentActions: function() {
	    $("#left-panel").hide();
	    $("#right-panel").addClass("no-padding");
	},
	showAlert: function() {
        var title = "Customers";
        var content = "Some message";
        var type = "alert";

        var params = {
            "_url": null,
            "_showProgressBar": null, //this.showActionProgressBar,
            "_hideProgressBar": null, //this.hideActionProgressBar,
            "_buttons": {
                "deleteBtn": null,
                "saveBtn": null,
                "cancelBtn": null,
                "copyBtn": null
            }
        }
        // 'content' parameter is passed as HTML, so be careful
        popup.show(title, content, type, params);
    },
	superRender: GenericView.prototype.render,
	render: function () {
	    this.superRender();
	    this.isFirstDisplay = false;

        this.$el.html(
            this.template({
			    userData: this.userData,
			    queueData: this.queueData,
			    counterData: this.counterData
		    })
		);

        $("#counter-name").html(this.counterData.name);

        this.showServingTicket();
        this.getServicingTicketBeginTime();
        this.updateNextPatient();

        //this.calculateDynamicFontSize($(".cuscode-dynamic"));
	},
	events:{
		"click #closeBtn": "closeCounter",
		"click #nextBtn": "nextInRowTicket",
		"click .nextSpecificTicketBtn": "nextSpecificTicket",
        "click .reAddTicketBtn": "reAddTicket",
        "click .servicedBtn": "servicedSpecificTicket",
		"click #closePreparationPopup": "closePreparationPopup",
		"click #createTicketPopup": "showPreparationPopup",
		"click .toggleTicketsMenu": "toggleTicketsMenu",
		"click .addTicketButton": "addTicketButton",
        "click .closeFormButton": "closeForm",
        "click #submitAddTicketFormButton": "addTicket",
		"submit #form": "addTicket",
		//"click #didNotComeBtn": "actionDidNotComeNextTicket",
	},
	getCustomerCodeLastDigits: function() {
	    if(!this.customerCode || this.customerCode.length <= 4)
	        return this.customerCode;

	    var indexFrom = this.customerCode.length - 4;

	    return this.customerCode.substring(indexFrom);
	},
	closePreparationPopup: function() {
	    var $popupEl = $("#preparationPopup");
        if($popupEl.hasClass('shown-preparation-popup'))
            $popupEl.removeClass('shown-preparation-popup');
    },
	showPreparationPopup: function(e) {
	    if(!this.currentTicket) {
            $(e.currentTarget).notify(i18n.t('counter.noServingCustomer'), { position:"top center", className: "info" });
	        return;
	    }

        var $popupEl = $("#preparationPopup");

	    if($popupEl.hasClass('shown-preparation-popup')) {
	        $popupEl.removeClass('shown-preparation-popup');
	        return;
	    }

        var ticketNum = this.currentTicket.displayNumber;
        var ticketNumber = "#" + ticketNum;

        var customerAndTicketData = {
            "ticketNum": ticketNumber,
            "fullCustomerName": this.getFullCustomerName(),
            "customerCode": this.getCustomerCodeLastDigits()
        };

        var templateData = this.preparationPopupTemplate(customerAndTicketData);

        $popupEl.html( templateData );

        this.bindPreparationPopupEvents();

        if(!$popupEl.hasClass('shown-preparation-popup'))
            $popupEl.addClass('shown-preparation-popup');
	},
	getServicingTicketBeginTime: function() {
	    //it will be checked on page load
        var isCurrentlyATicketBeingServed = (this.currentTicket && this.currentTicket.status == "Servicing"
                            && this.currentTicket.serviceBeginTime && !this.currentTicket.serviceEndTime);
	    var self = this;
	    if(isCurrentlyATicketBeingServed) {
	        //if a ticket is currently being served and the TIMER hasn't ended,
	        //but the timer has stopped (page reloaded), restart it with the remaining time
	        this.setCountdownForNextButton(this.currentTicket.serviceBeginTime);

            $('#minimumServiceTime').countdown("start");
            this.hasCountdownStarted = true;
	        // this.toggleNextButtons();
	    }
	},
	toggleLogs: function() {
	    $("#tickets_logs_container").slideToggle();

	},
	closeCounter: function() {
	    var self = this;
		this.showActionProgressBar();
        if(this.hasCountdownStarted === true) {
            this.setCountDownDefaultValue();
        }
        self.makeCloseRequest();
		// $.when(this.servicedTicket("makeCloseRequest")).then(function(resp) {
        //     if(resp == true || resp.data.status == "Pre_Serviced" || resp.data.status == "Serviced" || resp.data.status == "NotUsed") {
        //         self.makeCloseRequest();
        //     }
        // });
	},
	makeCloseRequest: function() {
		var data = { counterId: this.counterData.id};
		this.showActionProgressBar();
		this.doCall("rest/api/agent/counters/close", "POST", this.successCloseCounter,this.errorCloseCounter, data);
	},
	successCloseCounter: function(response, status, xhr, self) {
		self.hideActionProgressBar();
		window.open('./#AgentQueues','_self');
	},
	errorCloseCounter: function(response, self) {
		self.hideActionProgressBar();

	},
	amIAssigned: function() {
		this.doCall("rest/api/agent/counters/assigned?extra=queue", "GET", this.successAmIAssigned, this.errorAmIAssigned);

	},
	successAmIAssigned: function(response, status, xhr, self) {
  		if(status == "success")
		{
			if(response.data != null)
			{
			    if(response.data.counter.status == "Open") {
                    self.queueData = response.data.queue;
                    self.counterData = response.data.counter;
                    self.amIServingTicket();
                    return;
                }
			}
		}
		window.open('./','_self');
	},
	errorAmIAssigned: function(response, self) {
		window.open('./','_self');

	},
	amIServingTicket: function() {
		this.doCall("rest/api/agent/tickets/current?queueId="+ encodeURIComponent(this.queueData.id) +"&extra=customer", "GET", this.successAmIServingTicket, this.errorAmIServingTicket );

	},
	successAmIServingTicket: function(response, status, xhr, self) {
		if(status == "success")
		{
			if(response.data != null && response.data.ticket != null)
			{
				self.currentTicket = response.data.ticket.id != null ? response.data.ticket : null
				self.customerCode = response.data.customer != null ? response.data.customer.customerCode : null;

				self.currentCustomerInfo.firstName = response.data.customer != null ? response.data.customer.firstName : null;
                self.currentCustomerInfo.lastName = response.data.customer != null ? response.data.customer.lastName : null;
                self.currentCustomerInfo.customerId = response.data.customer != null ? response.data.customer.id : null;

				self.nextCustomerCode = response.data.ticket.nextCustomerCode;
                self.nextTicketNumber = response.data.ticket.nextTicketNumber;
			}else {
                self.nextCustomerCode = response.data != null ? response.data.nextCustomerCode : null;
                self.nextTicketNumber = response.data != null ? response.data.nextTicketNumber : null;
                self.nextCustomerNumberOfPeople = response.data != null ? response.data.numberPeople : null;
                // self.nextCustomerTicket = response.data != null && response.data.nextTicketNumber != null && response.data.nextTicketNumber != null ? response.data.nextTicketNumber : null;
                // self.nextCustomerData = response.data != null && response.data.nextCustomer != null && response.data.nextCustomerCode != null  ? response.data.nextCustomerCode : null;
			}
			self.updateNextPatient();
		}
		self.loadQueueStatistics();
	},
	errorAmIServingTicket: function(response, self) {
	    $.notify(i18n.t('counter.noPendingTickets'), { position:"top center", className: "info" });

		self.loadQueueStatistics();
	},
	showServingTicket: function() {
		$("#servingTickets").html(i18n.t("agent.serving")+"<br/>" +this.getServingTicketPrompt());
		// this.updateCustomerCode();
	},
	nonEmptyString: function(str) {
	    return str != null && str.trim().length > 0;

	},
	getFullCustomerName: function() {
	    return this.nonEmptyString(this.currentCustomerInfo.firstName) && this.nonEmptyString(this.currentCustomerInfo.lastName)
            ? this.currentCustomerInfo.firstName +" "+ this.currentCustomerInfo.lastName
            : this.nonEmptyString(this.currentCustomerInfo.firstName)
                ? this.currentCustomerInfo.firstName
                : this.nonEmptyString(this.currentCustomerInfo.lastName)
                    ? this.currentCustomerInfo.lastName
                    : "("+ i18n.t('counter.noCustomerName') +")";
	},
	updateCustomerCode: function() {
	    var self = this;
	    var customerName = this.getFullCustomerName();

        var nonServingText = "(" + i18n.t('counter.noServingCustomer') + ")"

	    var nameOrEmpty = self.currentTicket ? customerName : nonServingText; //i18n.t("counter.cuscode") + "<br/>";
	    var customerCodeOrEmpty = self.currentTicket && self.customerCode != null ? self.getCustomerCodeLastDigits() : ""

	    $("#customerFullName").text(nameOrEmpty);
		$("#customerCode").text(customerCodeOrEmpty);

		//this.calculateDynamicFontSize($(".cuscode-dynamic"))
	},
	calculateDynamicFontSize(elemRef) {
	    elemRef.dynamicFontSize({
            maximumFontSize: 32,
            minimumFontSize: 20,
            horizontalAlign: "center",
            horizontalAlignMargin: false, //use margin to horizontal alignment
            verticalAlign: "middle",
            wordBreak: null,
            error: 5 //accepted error, in percentage value {0-100}
        });
	},
	getServingTicketPrompt: function() {
		if(this.currentTicket == null)
			return "-";

        // we create the "A or "P" or "E" named, ticket number, in the backend
        return "#" + this.currentTicket.displayNumber;
	},
	loadQueueStatistics: function() {
        this.queueStatisticsCollection.url =  "rest/api/statistics/queues?filter=" + encodeURIComponent("queue="+this.queueData.id+",date>=" + this.getTodayWithOffset(0) + ", date<=" + this.getTodayWithOffset(0));
        this.queueStatisticsCollection.getFirstPage();
	},
	successQueueStatistics: function(response, status, xhr) {
	    var self = this;
		if(this.isFirstDisplay)
		{
			this.setListener();
            this.interval = setInterval(function() { self.checkAndRenewSocketJSConnections(self); }, 10 * 1000);

			this.render();

			this.getAllTickets();
			this.getAllPreparations();
		}

		if(this.queueStatisticsCollection.models.length > 0)
			this.queueStatistic = this.queueStatisticsCollection.models[0];

		this.updatePendingTickets();
	},
	updatePendingTickets: function() {
		if(this.queueStatistic){

			var pendingCount = "0"
			if(this.queueStatistic.attributes)
				pendingCount = this.queueStatistic.attributes.pendingCount;
			else
				pendingCount = this.queueStatistic.pendingCount;

			if(pendingCount < 0)
				pendingCount = 0;

			$('#pendingTickets').html(i18n.t("counter.ticket", {"count": pendingCount}));
		}

	},
	updateNextPatient: function() {
	    var self = this;
        var ticket_number = self.nextTicketNumber  ? self.nextTicketNumber : "-";
        var customer_code = self.nextCustomerCode  ? "( " +self.nextCustomerCode  +" )" : "";

        $("#ticket-number").text(ticket_number);
        $("#next-patient-code").text(customer_code);

        if(((self.nextCustomerCode && self.nextTicketNumber) || (self.nextCustomerData && self.nextCustomerTicket)) && self.nextCustomerNumberOfPeople && self.nextCustomerNumberOfPeople > 0) {
            var nextCustomerTicketNumber = ticket_number !== "-" ? ticket_number : self.nextCustomerTicket.number;
            $('#nextCustomerTicketNumber').html(`<span style="font-weight: bold;"><i class="fa fa-ticket-alt"></i></span>&nbsp;<span class="ticket-row-customer-code">${nextCustomerTicketNumber}</span>`);
            $('#numberOfPeople').html(`<span style="font-weight: bold;"><i class="fas fa-users"></i></span>&nbsp;<span class="ticket-row-customer-code">${self.nextCustomerNumberOfPeople}</span>`);
        } else {
            $("#nextCustomerTicketNumber").text("");
            $("#numberOfPeople").text("");
        }
	},
	removeOnePendingTickets: function() {
		this.queueStatisticsCollection.models[0].attributes.pendingCount = this.queueStatisticsCollection.models[0].attributes.pendingCount -1;

	},
	errorQueueStatistics: function(collection, self) {
		this.onErrorHandler(response, xhr, options);
		this.render();
	},
	toggleNextButtons: function() {
	    var self = this;

        this.nextButtonClicked = false;

        if(!this.currentTicket) { //no more tickets to serve
            //return NEXT buttons, to their initial state
            //$("#nextBtn").prop('disabled', false);
            //$("#didNotComeBtn").prop('disabled', true);
            // this.enableNextBtn();

            $("#nextBtnCountdown").show();
            $("#nextBtnDefault").hide();
            return;
        // } else if (this.currentTicket) {
        //     this.enableNextBtn();
        //     return;
        }

        //toggle enabled/disabled on `NEXT` & `DID NOT COME` buttons
    	//$("#nextBtn").prop('disabled', !($("#nextBtn").prop('disabled')));
        //$("#didNotComeBtn").prop('disabled', !($("#didNotComeBtn").prop('disabled')));

        // this.disableNextBtn();
        // $("#nextBtn").toggle();
        // $("#didNotComeBtn").toggle();
        // $("#nextBtnCountdown").hide();
        // $("#nextBtnDefault").show();

        this.loadQueueStatistics();
	},
	errorCallback: function(response, self) {
	    console.error("Error: ", response);

	},
	getFormattedRemainingMinutes: function(minutes) {
	    return Handlebars.helpers.getFormattedRemainingMinutes(minutes);

	},
	setCountdownForNextButton: function(dateFrom) {
	    var self = this;

        //pass a `dateFrom`, in case the timer has already begun and for some reason the page was reloaded,
        //so the timer can know from which time to start the countdown (continue with the current remaining time and not the initial one)
        // minServiceTime is in Seconds
	    var finalDate = new Date((dateFrom != null ? dateFrom : Date.now()) + (this.queueData.minServiceTime * 1000));

        $("#minimumServiceTime").countdown(finalDate)
        .off('update.countdown').on('update.countdown', function(event) {
            $(this).text(event.strftime('%M:%S'));
        }).off('finish.countdown').on('finish.countdown', function(event) {
            self.toggleNextButtons();
            $("#nextBtnCountdown").hide();
            $("#nextBtnDefault").show();
            self.enableNextBtn();
            $(this).text(self.getFormattedRemainingMinutes(self.queueData.minServiceTime));
        }).off('stop.countdown').on('stop.countdown', function(event) {
            self.toggleNextButtons();
            this.hasCountdownStarted = false;
            $(this).text(self.getFormattedRemainingMinutes(self.queueData.minServiceTime));
        });
	},
	setCountdownForElement: function(dateFrom, elem) {
        var self = this;

        //pass a `dateFrom`, in case the timer has already begun and for some reason the page was reloaded,
        //so the timer can know from which time to start the countdown (continue with the current remaining time and not the initial one)
        // minServiceTime is in Seconds
        var finalDate = new Date(dateFrom != null ? dateFrom : Date.now());

        elem.countdown(finalDate)
        .off('update.countdown').on('update.countdown', function(event) {
            $(this).text(event.strftime('%H:%M:%S'));

        }).off('finish.countdown').on('finish.countdown', function(event) {
            $(this).text("00:00:00");
            $(this).addClass('preparationTimeDone');

        }).off('stop.countdown').on('stop.countdown', function(event) {
            //$(this).text(self.getFormattedRemainingMinutes(self.queueData.minServiceTime));
            this.hasCountdownStarted = false;
        });
    },
	setCountDownDefaultValue: function() {
	    $('#minimumServiceTime').countdown("stop");
        this.hasCountdownStarted = false;
        $("#minimumServiceTime").text(this.getFormattedRemainingMinutes(this.queueData.minServiceTime));
        $("#nextBtnCountdown").hide();
        $("#nextBtnDefault").show();
	},
	actionNextTicket: function() {
	    var self = this;

        // disable "mistaken" click on NEXT button, while the popup is visible
	    if($("#preparationPopup").hasClass('shown-preparation-popup'))
	        return;

	    if(this.nextButtonClicked == true)
	        return;

	    this.nextButtonClicked = true;

	    var self = this;
		this.showActionProgressBar();

		// var hasTicketBeenServed = $.when(this.servicedTicket("nextTicket")).then(function(resp) {
        //     return resp == true || resp.data.status == "Serviced" || resp.data.status == "Pre_Serviced";
        // });

        // if(!hasTicketBeenServed)
        //     return;

        this.setCountdownForNextButton();
        $("#nextBtnCountdown").show();
        $("#nextBtnDefault").hide();
        $('#minimumServiceTime').countdown('start');
        this.hasCountdownStarted = true;

        this.nextTicket(true);
	},
	nextInRowTicket: function() {
        this.specificNext = false;
        this.actionNextTicket();
    },
	nextSpecificTicket: function(e) {
	    this.specificNext = true;
	    this.specificTicketId = $(e.currentTarget).data("ticketid");
	    this.actionNextTicket();
	},
    reAddTicket: function(e) {
		var self = this;

	    var reAddicketId = $(e.currentTarget).data("ticketid");

		this.showActionProgressBar();

        $.ajaxDefaultQ({
            url: 'rest/api/agent/tickets/reissue?queueId=' + this.queueData.id + '&ticketId=' + reAddicketId,
            type: 'POST',
            contentType: "application/json"
        }).done(function(response, status, xhr){
            if(status == "success")
            {
                self.hideActionProgressBar();
            }else {
                self.hideActionProgressBar();
                console.log("resp: ",response);
                console.log("status: ",status);
            }
        })
        .fail(function(response) {
                self.hideActionProgressBar();

                if(response.status === 409) {
                    $.notify(i18n.t('counter.customerDailyLimit'), { position:"top center", className: "info" });
                } else {
                    $.notify(i18n.t('user.error'), { position:"top center", className: "info" });
                }

            });

        
		return false;
    },
	actionDidNotComeNextTicket: function() {
	    var self = this;
		this.showActionProgressBar();

		// this.setCountDownDefaultValue();
		this.nextTicket(false);

		// this.setCountdownForNextButton();
		//toggle NEXT/DID_NOT_COME buttons (disabled/enabled)

		this.toggleNextButtons();
	},
	nextTicket: function(hasCustomerCome) {
		var self = this;
		if (this.specificNext == true) {
            var data = {
                "queueId": +this.queueData.id,
                "ticketId": +this.specificTicketId
            }
		} else {
		    var data = "queueId="+this.queueData.id;
		}

		var url = "rest/api/agent/tickets";

		if(!hasCustomerCome) {
		    url += "/didNotCome/next";
		    data += this.currentTicket ? "&ticketId=" + this.currentTicket.id : "";
		}else {
		    url += this.specificNext ==  true ? "/servicing" : "/servicingAuto";
		}

        // block the button to avoid multiple clicks
		this.disableNextBtn();

		this.doCall(url, "POST",
			function(response, status, xhr){
				self.hideActionProgressBar();

                if(response && response.data && response.data && response.data.error) {
                    //$("#nextBtn").notify(response.data.error, { position:"top center", className: "error" });
                    console.error(response.data.error);
                }

                if(response && response.data == "NextBlocked") {
                    $("#nextBtn").notify(i18n.t('counter.blockedByAdmin'),
                    {
                        position:"top center",
                        className: "info",
                        autoHideDelay: 10000
                    });
                }

				self.currentTicket = response.data != null && response.data.ticket != null && response.data.ticket.id != null ? response.data.ticket : null;
                self.customerCode = response.data != null && response.data.customer != null && response.data.customer.customerCode != null  ? response.data.customer.customerCode : "-";

				self.nextCustomerTicket = response.data != null && response.data.nextTicket != null && response.data.nextTicket.id != null ? response.data.nextTicket : null;
                self.nextCustomerData = response.data != null && response.data.nextCustomer != null && response.data.nextCustomer.customerCode != null  ? response.data.nextCustomer : null;
                self.nextCustomerNumberOfPeople = response.data != null && response.data.nextTicket != null && response.data.nextTicket.numberPeople != null ? response.data.nextTicket.numberPeople : null;
                
                self.currentCustomerInfo.firstName = response.data != null && response.data.customer != null ? response.data.customer.firstName : null;
                self.currentCustomerInfo.lastName = response.data != null && response.data.customer != null ? response.data.customer.lastName : null;
                self.currentCustomerInfo.customerId = response.data != null && response.data.customer != null ? response.data.customer.id : null;


				self.nextCustomerCode = response.data != null && response.data.ticket != null ? response.data.ticket.nextCustomerCode : null;
				self.nextTicketNumber = response.data != null && response.data.ticket != null ? response.data.ticket.nextTicketNumber : null;

				if(response && response.data.customer && response.data.customer.deviceOs == "NoDevice")
					self.currentPhone = response.data.customer.deviceId;
				else
					self.currentPhone = null;

				self.updatePendingTickets();
				self.showServingTicket();
                self.updateNextPatient();
				self.toggleNextButtons();

				self.getAllTickets();

				// unblock the button
                if(!hasCustomerCome) {
                    self.enableNextBtn();
                }
			},
			function(status){
				self.hideActionProgressBar();
				self.currentTicket = null;
				self.currentPhone = null;
				self.updatePendingTickets();
				self.showServingTicket();
                self.updateNextPatient();
				self.toggleNextButtons();
				self.setCountDownDefaultValue();

				$("#nextBtn").notify(i18n.t('counter.noPendingTickets'), { position:"top center", className: "info" });

				self.getAllTickets();

				// unblock the button
				self.enableNextBtn();
			},
			data
		);
	},
	servicedTicket: function(nextMethod) {
		if(this.currentTicket == null) {
		    this.hideActionProgressBar();
		    return true;
		}

		var self = this;
		return this.doCall("rest/api/agent/tickets/serviced?id="+this.currentTicket.id+"&callback="+nextMethod, "POST",
			function(response, status, xhr){
				self.hideActionProgressBar();

				if(nextMethod == "nextTicket")
				{
					//self.nextTicket(true);
					//Agent will click by hand the NEXT

				}
				else if(nextMethod == "makeCloseRequest")
				{
					//self.makeCloseRequest();
				}
                return response.data.status;
			},
			function(status, self){
			    self.hideActionProgressBar();
				self.currentTicket = null;

				$.notify(i18n.t('counter.noPendingTickets'), { position:"top center", className: "info" });

				if(nextMethod == "nextTicket")
				{
					//self.nextTicket(true);
					//Agent will click by hand the NEXT
				}
				else if(nextMethod == "closeCounter")
				{
					//self.makeCloseRequest();
				}
				return true;
			}
		);
	},
    servicedSpecificTicket: function(e) {
        // if(this.currentTicket == null) {
		//     this.hideActionProgressBar();
		//     return true;
		// }
	    var ticketId = $(e.currentTarget).data("ticketid");

		var self = this;

		return this.doCall("rest/api/agent/tickets/serviced?queueId="+this.queueData.id+"&ticketId="+ticketId, "POST",
			function(response, status, xhr){
				self.hideActionProgressBar();
                return response.data.status;
			},
			function(status, self){
			    self.hideActionProgressBar();
				self.currentTicket = null;

				$.notify(i18n.t('counter.noPendingTickets'), { position:"top center", className: "info" });
				return true;
			}
		);
    },
	doCall: function(url, type, successCallback, errorCallback, data) {
		if(!data)
			data = "";

		var self = this;
		return $.ajaxDefaultQ({
            url: url,
            type: type,
            data: data
        }).done(function(response, status, xhr){
			successCallback(response, status, xhr, self);
        })
        .fail(function(response) {
        	errorCallback(response, self);
        });
	},
	setListener: function() {
		var self = this;

		this.wsocket = new SockJS('rest/live');
		this.client = Stomp.over(this.wsocket);

		var headers = {
			//origin: 'https://www.qedis-metro.com', toDo: enable it
		};

		this.client.connect(headers,
		    function(frame) {
                self.subscribeToStomp(self);
		    },
            function(onCloseMessage) {
                if(onCloseMessage.indexOf('Whoops! Lost connection to') > -1) {
                    self.clearListener("onConnectionClosed");
                }
            }
        );
	},
	subscribeToStomp: function(self) {
	    self.counterStompSubscription.push(self.client.subscribe('/live/monitors/counters/' + self.counterData.id, function (message){
            var responseObject = JSON.parse( message.body );
            if(responseObject.serverMessage) {
                $.notify(responseObject.serverMessage, { position:"top center", className: "info" , autoHide: false, clickToHide: true});
                return;
            }

            self.loadQueueStatistics();
            self.customerCode = responseObject.customerCode;
            self.updateCustomerCode();

            //self.nextCustomerCode = responseObject.nextCustomerCode;
            //self.nextTicketNumber = responseObject.nextTicketNumber;
            //self.updateNextPatient();

            self.getAllTickets();
        }));

        self.counterStompSubscription.push(self.client.subscribe('/live/monitors/counter/tickets/queue/' + self.queueData.id, function (message) {
            var responseObject = JSON.parse( message.body );
            var counterId = responseObject.counterId;

            // reload all tickets, if another counter has clicked on NEXT
            if(self.counterData.id != counterId || (responseObject.allInQueue == true))
                self.getAllTickets();
        }));

        self.counterStompSubscription.push(self.client.subscribe('/live/monitors/counter/preparations/queue/' + self.queueData.id, function (message) {
            var responseObject = JSON.parse( message.body );
            var counterId = responseObject.counterId;

            // reload all preparations, if another counter has added a customer in the preparation list
            if(self.counterData.id != counterId)
                self.getAllPreparations();
        }));
	},
	checkAndRenewSocketJSConnections: function(self) {
        //console.log(">>> Checking for non-connected client.");
	    if(self.client && (!self.client.connected || !self.counterStompSubscription)) {
	        //console.log("Found non-connected client. Trying to reconnect...");
	        //self.setListener();
	        self.subscribeToStomp(self);
	    }else {
	        //console.log("No disconnected client found.");
	    }
	},
	clearListener: function(reason) {
        if(!this.client || !this.counterStompSubscription || this.counterStompSubscription.length == 0 || this.alreadyRequestedClear)
            return;

        this.alreadyRequestedClear = true;

        $.each(this.counterStompSubscription, function(index, subscription) {
            subscription.unsubscribe();
        });

        /*this.client.disconnect(function() {

        });*/

        this.alreadyRequestedClear = false;
	},
	clearView: function() {
		this.clearListener("clearview");

	},
	getAllTickets: function() {
        var self = this;
        var $addTicketButton = $("#counterMonitor-columns").find(".addTicketButton");

        if(!this.queueData || this.queueData.id <= 0) {
            $("#tickets-container-text").notify(i18n.t("server.errorOccurred"), { position:"bottom center", className: "error" });
            return;
        }

        var url = "rest/api/agent/counters/getAllTickets/"+ this.queueData.id;
        $.ajaxDefaultQ({
            url: url,
            type: "GET",
            data: {}
        }).done(function(response, status, xhr){

            const statuses = {
                "Pending": 1,
                "Servicing": 2,
                "NotUsed": 3,
                "Serviced": 4
            };
            var sortedTickets = response.data.sort((a, b) => statuses[a.ticket.status] - statuses[b.ticket.status]);

            $("#ticketsContainer").html(self.ticketsTemplate({tickets: sortedTickets, queue: self.queueData}));

            $("#tickets-container-text").notify(i18n.t("counter.refreshed"), { position:"bottom center", className: "info" });

            // if($addTicketButton.hasClass("toggled")){
            //     $addTicketButton.removeClass("toggled")
            // }
        })
        .fail(function(response) {
            self.errorCallback(response, self);
        });
    },
    getAllPreparations: function() {
        var self = this;

        if(this.queueData.needsPreparation == false)
            return;

        if(!this.queueData || this.queueData.id <= 0) {
            $("#tickets-container-text").notify(i18n.t("server.errorOccurred"), { position:"bottom center", className: "error" });
            return;
        }

        var url = "rest/api/agent/counters/getAllPreparations/"+ this.queueData.id;

        $.ajaxDefaultQ({
            url: url,
            type: "GET",
            data: {}
        }).done(function(response, status, xhr){
            self.preparationsList = response.data;

            $("#pendingCustomerContainer").html(self.preparationsTemplate(self.preparationsList));

            $(".pendingCustomersHeader").notify(i18n.t("counter.refreshed"), { position:"bottom center", className: "info" });

            self.bindPreparationCustomersEvents();

            $.each(response.data, function(key, value) {

                var dateFrom = value.date;
                var elem = $("#pendingCustomerContainer").find('[data-id="'+ value.preparationId +'"]').find(".pending-row-customer-timeLeft");

                self.setCountdownForElement(dateFrom, elem);
            });

        })
        .fail(function(response) {
            self.errorCallback(response, self);
        });
    },
    bindPreparationCustomersEvents: function() {
        var self = this;

        $("#pendingCustomerContainer .pending-row-customer-createTicket").unbind("click").on("click", function(evt) {

            var preparationId = parseInt($(this).parent().parent().data("id"));

            if( isNaN(preparationId) ) {
                return;
            }

            var foundPreparations = $.grep(self.preparationsList, function(v, k) {

                return v.preparationId == preparationId;
            });

            if(foundPreparations && foundPreparations.length != 1) {
                $(this).notify(i18n.t("server.errorOccurred"),
                {
                    position:"top center",
                    className: "error",
                    autoHide: true
                });

                return;
            }

            var foundPreparation = foundPreparations[0];

            var $elem = $("#nextBtn");
            var $_this = $(this);

            $.ajaxDefaultQ({
                url: "rest/api/agent/counters/issueImmediateTicket?preparationId=" + foundPreparation.preparationId,
                type: "POST",
                contentType: "application/json",
                data: {}

            }).done(function(response, status, xhr){

                if(response != null) {

                    var text = "";
                    var className = "";

                    if(response.error != null) {
                        text = i18n.t("server.errorOccurred");
                        className = "error";
                    }
                    else if(response.data == "Success") {
                        $_this.find(".reissueText").show();

                        text = i18n.t('counter.issuedTicketSuccess');
                        className = "success";
                    }
                    else if(response.data == "QueueClosed") {
                        text = i18n.t("counter.queueClosed");
                        className = "info";
                    }
                    else if(response.data == "CustomerDailyLimit") {
                        text = i18n.t("counter.customerDailyLimit");
                        className = "info";
                    }
                    else if(response.data == "QueueDailyLimit") {
                        text = i18n.t("counter.queueDailyLimit");
                        className = "info";
                    }
                    else if(response.data == "CustomerAlreadyHasTicket") {
                        text = i18n.t("counter.customerAlreadyHasTicket");
                        className = "info";
                    }
                    else if(response.data == "CustomerNotExist") {
                        text = i18n.t("counter.CustomerNotExist");
                        className = "error";
                    }
                    else {
                        text = i18n.t("server.errorOccurred");
                        className = "error";
                    }

                    $elem.notify(text,
                    {
                        position: "top center",
                        className: className,
                        autoHide: true
                    });

                }
                else {
                    $elem.notify(i18n.t("server.errorOccurred"),
                    {
                        position: "top center",
                        className: "error",
                        autoHide: true
                    });

                }

            })
            .fail(function(response) {
                $elem.notify(i18n.t("server.errorOccurred"),
                {
                    position: "top center",
                    className: "error",
                    autoHide: true
                });

            });
        });

    },
    bindPreparationPopupEvents: function() {
        var self = this;

        $("#submitPreparation").unbind("click").on("click", function(evt) {

            var minutes = parseInt($("#preparationMinutes").val());

            var $elem = $(this);

            if(minutes == null || minutes == "" || isNaN(minutes) || parseInt(minutes) <= 0 || (parseFloat(minutes) % 1 != 0)) {

                var text = i18n.t("queue.nonNumericValue");

                if(parseInt(value) <= 0)
                    text = i18n.t("queue.valueMoreThan", {value: 0})

                $elem.notify(text,
                {
                    position:"top center",
                    className: "error",
                    autoHide: true
                });

                return;
            }

            var preparation = {
                "preparationId": null,
                "queueId": self.queueData.id,
                "firstName": self.currentCustomerInfo.firstName,
                "lastName": self.currentCustomerInfo.lastName,
                "customerId": self.currentCustomerInfo.customerId,
                //"status": false,
                //"date": new Date().getTime(),
                "minutes": minutes
            }

            $.ajaxDefaultQ({
                url: "rest/api/preparations",
                type: "POST",
                contentType: "application/json",
                data: JSON.stringify(preparation)

            }).done(function(response, status, xhr){

                if(response != null) {

                    var text = "";
                    var className = "";

                    if(response.data == "AlreadyInList") {
                        text = i18n.t("counter.alreadyInPreparationList");
                        className = "info";
                    }
                    else if(response.data == "QueueClosed") {
                        text = i18n.t("counter.preparationOnClosedQueue");
                        className = "warning";
                    }
                    else {
                        text = i18n.t("counter.addedPreparationSuccessfully");
                        className = "success";

                        self.getAllPreparations();
                    }

                    $("#createTicketPopup").notify(text,
                    {
                        position: "top center",
                        className: className,
                        autoHide: true
                    });

                    self.closePreparationPopup();

                }
                else {
                    $elem.notify(i18n.t("server.errorOccurred"),
                    {
                        position:"top center",
                        className: "error",
                        autoHide: true
                    });

                }

            })
            .fail(function(response) {
                $elem.notify(i18n.t("server.errorOccurred"),
                {
                    position:"top center",
                    className: "error",
                    autoHide: true
                });

            });

        });
    },
    toggleTicketsMenu: function() {
        var $1stColumn = $("#counterMonitor-columns").find(".cm-1st-column");
        var $2ndColumn = $("#counterMonitor-columns").find(".cm-2nd-column");
        var $ticketsToggle = $("#counterMonitor-columns").find(".toggleTicketsMenu");

        if(this.isTicketsContainerShown) {
            if(this.queueData.needsPreparation) {

                if( $2ndColumn.hasClass("col-md-6") ) {
                    $2ndColumn.removeClass("col-md-6");
                    $2ndColumn.addClass("col-md-9");

                }
            }
            else {
                if( $2ndColumn.hasClass("col-md-9") ) {
                    $2ndColumn.removeClass("col-md-9");
                    $2ndColumn.addClass("col-md-12");

                }
            }

            $1stColumn.hide();

        }
        else {
            if(this.queueData.needsPreparation) {

                if( $2ndColumn.hasClass("col-md-9") ) {
                    $2ndColumn.removeClass("col-md-9");
                    $2ndColumn.addClass("col-md-6");

                }
            }
            else {
                if( $2ndColumn.hasClass("col-md-12") ) {
                    $2ndColumn.removeClass("col-md-12");
                    $2ndColumn.addClass("col-md-9");

                }
            }

            $1stColumn.show();
        }

        $ticketsToggle.toggleClass("toggled");
        $ticketsToggle.find("i").toggleClass("fa-chevron-right");
        $ticketsToggle.find("i").toggleClass("fa-times");

        this.isTicketsContainerShown = !this.isTicketsContainerShown;
    },
    addTicketButton: function() {
        var self = this;
        var $addTicketButton = $("#counterMonitor-columns").find(".addTicketButton");

        $("#addTicketContainer").html(self.addTicketTemplate());

        $addTicketButton.toggleClass("toggled");

        $("#addTicketContainer")[0].scrollIntoView({behavior: 'smooth'})
        
    },
    addTicket: function()
	{
		var self = this;

        var phoneNumber = encodeURIComponent($("#phoneNumber").val());
        var numberPeople = encodeURIComponent($("#numberPeople").val());
        var priority = Number(encodeURIComponent($("#priority").val()));

        var isPhoneNumberValid = /^(?:[0-9\-\\(\\)\\.]\s?){9,12}[0-9]{1}$/.test(phoneNumber);
        var isNumberPeopleValid = /^(?:[1-9]|\d\d\d*)$/.test(numberPeople);

        if(isPhoneNumberValid === true && isNumberPeopleValid === true) {
		    this.showActionProgressBar();

            $.ajaxDefaultQ({
                url: '/rest/api/payment/create',
                type: 'POST',
                contentType: "application/json",
                data: JSON.stringify({phoneNumber: phoneNumber, priorityTicket: priority, queueId: this.queueData.id, numberPeople: numberPeople}),
            }).done(function(response, status, xhr){
                if(status == "success")
                {
                    self.hideActionProgressBar();
                    $('#phoneNumber').val('')
                    $('#numberPeople').val('')
                }else {
                    self.hideActionProgressBar();
                    console.log("resp: ",response);
                    console.log("status: ",status);
                }
    
                $("#phoneNumber").unbind();
            })
        } else {
            if(isPhoneNumberValid === false) {

                var phoneNumberError = $("#phoneNumber").parent().find(".error-message");
                phoneNumberError.text(i18n.t('counter.phone_number_error')).show();
                // $('.error-message').text(i18n.t('counter.phone_number_error')).show();
            
                $("#phoneNumber").bind("change paste keyup", function() {
                    if(/^(?:[0-9\-\\(\\)\\.]\s?){9,12}[0-9]{1}$/.test($(this).val()) === true) {
                        phoneNumberError.hide();
                    } else {
                        phoneNumberError.text(i18n.t('counter.phone_number_error')).show();
                    }
                });
                // $.notify(
                    //     i18n.t("account.check_errors"),
                    //     { position:"top center", className: "error" }
                    // );
            }

            if(isNumberPeopleValid === false) {
                var numberPeopleError = $("#numberPeople").parent().find(".error-message");
                numberPeopleError.text(i18n.t('counter.number_of_people_error')).show();
                // $('.error-message').text(i18n.t('counter.phone_number_error')).show();
            
                $("#numberPeople").bind("change paste keyup", function() {
                    if(/^(?:[1-9]|\d\d\d*)$/.test($(this).val()) === true) {
                        numberPeopleError.hide();
                    } else {
                        numberPeopleError.text(i18n.t('counter.number_of_people_error')).show();
                    }
                });
            }
        }
        
		return false;
	},
    closeForm: function() 
    {
        var $addTicketFormContainer = $("#counterMonitor-columns").find(".addTicketFormContainer");
        var $addTicketButton = $("#counterMonitor-columns").find(".addTicketButton");

        $addTicketFormContainer.remove();
        $addTicketButton.removeClass("toggled");
    },
    disableNextBtn: function() {
        $("#nextBtn").attr("disabled", "disabled");

        if (this.queueData.searchable == true) {
            this.$el.find('.nextSpecificTicketBtn').prop('disabled', true);
        }
    },
    enableNextBtn: function() {
        $("#nextBtn").removeAttr("disabled");

        if (this.queueData.searchable == true) {
            this.$el.find('.nextSpecificTicketBtn').prop('disabled', false);
        }
    }
});

module.exports = TheView;